// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"98ae622d","275":"0e7d7892","455":"88b12aa4","904":"20c84528","977":"133710af"}[chunkId] + ".chunk.js";
};